import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router';
import { Toaster } from '@/components/ui/sonner';
import { FeatureFlagsProvider } from '@/lib/feature-flags';
import { initSentry } from '@/lib/sentry';
import { queryClient } from '@/lib/query-client';
import { router } from './router';
import './index.css';

initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <FeatureFlagsProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster richColors />
        {
          // Skip under automation: the devtools' kobalte dependency reads navigator.language, which the Playwright/Firefox QA harness reports as "undefined", so Intl throws an uncaught RangeError on every route. Real browsers report a valid tag, so human dev keeps the devtools.
          import.meta.env.DEV && !navigator.webdriver && (
            <ReactQueryDevtools initialIsOpen={false} />
          )
        }
      </QueryClientProvider>
    </FeatureFlagsProvider>
  </StrictMode>,
);
